import { render, staticRenderFns } from "./productBenefitAction.vue?vue&type=template&id=16b6c14f&scoped=true&"
import script from "./productBenefitAction.vue?vue&type=script&lang=js&"
export * from "./productBenefitAction.vue?vue&type=script&lang=js&"
import style0 from "./productBenefitAction.vue?vue&type=style&index=0&id=16b6c14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b6c14f",
  null
  
)

export default component.exports